import type { ClientContext } from '~/services/contextClient';
import type { OutboundMessagesAnalyticsClientInterface } from './outboundMessagesAnalyticsClient.types';
import CorporateOutboundMessagesAnalyticsClient from './corporateOutboundMessagesAnalyticsClient';
import GroupOutboundMessagesAnalyticsClient from './groupOutboundMessagesAnalyticsClient';
import OrgUnitOutboundMessagesAnalyticsClient from './orgUnitOutboundMessagesAnalyticsClient';
import type { BaseClientConfig } from '~/services/BaseClient';

export default class OutboundMessagesAnalyticsClientFactory {
    static createClient(
        context: ClientContext,
        config: BaseClientConfig = {}
    ): OutboundMessagesAnalyticsClientInterface {
        if (!context.orgUnitId && !context.groupId) {
            return new CorporateOutboundMessagesAnalyticsClient(context.teamId, config);
        } else if (context.orgUnitId) {
            return new OrgUnitOutboundMessagesAnalyticsClient(context.teamId, context.orgUnitId, config);
        } else if (context.groupId) {
            return new GroupOutboundMessagesAnalyticsClient(context.teamId, context.groupId, config);
        }

        throw new Error('Invalid context');
    }
}
